 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"LidaTable":"LidaTable","acout":"acout","announcement":"announcement","assort-frist":"assort-frist","assort-ledger":"assort-ledger","common":"common","game-management":"game-management","general-ledger":"general-ledger","liveshow":"liveshow","livshow-adjust-odds":"livshow-adjust-odds","lottery-kind":"lottery-kind","open-management":"open-management","operator":"operator","operator-group":"operator-group","otherSiteList":"otherSiteList","period-management":"period-management","personalCenter":"personalCenter","setting":"setting","tool_mintable":"tool_mintable","tool_retime":"tool_retime","traderecord":"traderecord","GameGearing":"GameGearing","ModalAcountFix":"ModalAcountFix","ModalSiteLog":"ModalSiteLog","ModalSiteSettings":"ModalSiteSettings","ModalEditInside":"ModalEditInside","liveshow-NavSettingTool":"liveshow-NavSettingTool","liveshow-components":"liveshow-components","liveshow-liveshowGameTabs":"liveshow-liveshowGameTabs","tool-ModalBettingList":"tool-ModalBettingList","ModalBallStatus":"ModalBallStatus","period_management":"period_management","QuickOddChangeModal":"QuickOddChangeModal","liveshow-AlertNotice":"liveshow-AlertNotice","openBacoAllTime":"openBacoAllTime","openBacoTime":"openBacoTime","GameCloseTimer":"GameCloseTimer","ModalTableKeno":"ModalTableKeno","ModalTablePk10":"ModalTablePk10","ModalTableQuick10":"ModalTableQuick10","ModalTableQuick3":"ModalTableQuick3","ModalTableSelect5":"ModalTableSelect5","ModalTableSixmark":"ModalTableSixmark","ModalTableSixmarkDaily":"ModalTableSixmarkDaily","ModalTableSsc":"ModalTableSsc"}[chunkId]||chunkId) + "." + {"LidaTable":"89f82c9c","acout":"88713485","announcement":"9923d5ce","assort-frist":"0f140069","assort-ledger":"f4cb70dc","chunk-2d0aba47":"8e4915ea","chunk-2d0b6927":"a96e7abd","chunk-2d0ba88a":"33517601","chunk-2d0bce16":"24a40751","chunk-2d0c46b1":"697f1c3d","chunk-2d0d9f53":"6bc08a1a","chunk-2d0e5b1a":"3ad3ed77","chunk-2d0e91ef":"369fe4f8","chunk-2d21d846":"1f9a509b","chunk-2d22c8c1":"d6067c46","chunk-2d230be8":"ec140fe9","chunk-7f1cb5d0":"6a45b0a0","common":"9c0582ac","game-management":"9f9e9018","general-ledger":"47f33a2c","liveshow":"136916c4","livshow-adjust-odds":"3fd91da3","lottery-kind":"480a4c03","open-management":"9f334c5b","operator":"e9c5db7b","operator-group":"4d58ee50","otherSiteList":"fb2dc212","period-management":"ee732068","personalCenter":"017c701a","setting":"57150cf1","tool_mintable":"5a01f8fa","tool_retime":"129d029a","traderecord":"d4b66c6e","GameGearing":"c2340435","ModalAcountFix":"9eb1f24c","ModalSiteLog":"d6a644f6","ModalSiteSettings":"8b3ae701","chunk-e5057956":"6d39e75c","ModalEditInside":"06fb6aad","chunk-2d21675b":"bde8ffa0","liveshow-NavSettingTool":"9a89bf6c","liveshow-components":"a9f3f299","liveshow-liveshowGameTabs":"e2e31d7e","tool-ModalBettingList":"58ba3690","chunk-10dd34ae":"d3aa5cf1","chunk-38c315be":"88800c00","chunk-3a43bc6e":"27083679","chunk-3f4cb1ae":"bcfc8007","chunk-42695a73":"d7629218","chunk-42709d36":"87c76b80","chunk-4946a530":"098770c4","chunk-75654c40":"db9e5ef9","chunk-9bfb6b88":"078b4072","chunk-a16e5492":"d83b1d97","chunk-b4eb857e":"a6b0a69c","chunk-cf7dbe66":"22327c24","chunk-d5325f7a":"9c96de05","ModalBallStatus":"081c31e9","period_management":"7a6d5cc7","QuickOddChangeModal":"e04bb70f","liveshow-AlertNotice":"f44238f2","openBacoAllTime":"1f37a98d","openBacoTime":"d5a91d8a","chunk-2d0de8f6":"6fcd122f","chunk-67f905ec":"22a10244","chunk-ea63f694":"8239f0f3","GameCloseTimer":"7426cdd8","ModalTableKeno":"f48ce21b","ModalTablePk10":"9117e375","ModalTableQuick10":"faf4b948","ModalTableQuick3":"ecbade2d","ModalTableSelect5":"1d91d4c7","ModalTableSixmark":"8835dc5a","ModalTableSixmarkDaily":"fad696a5","ModalTableSsc":"c91d6f9e"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"LidaTable":1,"acout":1,"assort-ledger":1,"chunk-7f1cb5d0":1,"game-management":1,"general-ledger":1,"liveshow":1,"livshow-adjust-odds":1,"lottery-kind":1,"open-management":1,"operator-group":1,"otherSiteList":1,"setting":1,"chunk-e5057956":1,"liveshow-NavSettingTool":1,"liveshow-components":1,"liveshow-liveshowGameTabs":1,"chunk-9bfb6b88":1,"chunk-b4eb857e":1,"chunk-d5325f7a":1,"ModalBallStatus":1,"QuickOddChangeModal":1,"liveshow-AlertNotice":1,"chunk-67f905ec":1,"chunk-ea63f694":1,"ModalTableSixmarkDaily":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"LidaTable":"LidaTable","acout":"acout","announcement":"announcement","assort-frist":"assort-frist","assort-ledger":"assort-ledger","common":"common","game-management":"game-management","general-ledger":"general-ledger","liveshow":"liveshow","livshow-adjust-odds":"livshow-adjust-odds","lottery-kind":"lottery-kind","open-management":"open-management","operator":"operator","operator-group":"operator-group","otherSiteList":"otherSiteList","period-management":"period-management","personalCenter":"personalCenter","setting":"setting","tool_mintable":"tool_mintable","tool_retime":"tool_retime","traderecord":"traderecord","GameGearing":"GameGearing","ModalAcountFix":"ModalAcountFix","ModalSiteLog":"ModalSiteLog","ModalSiteSettings":"ModalSiteSettings","ModalEditInside":"ModalEditInside","liveshow-NavSettingTool":"liveshow-NavSettingTool","liveshow-components":"liveshow-components","liveshow-liveshowGameTabs":"liveshow-liveshowGameTabs","tool-ModalBettingList":"tool-ModalBettingList","ModalBallStatus":"ModalBallStatus","period_management":"period_management","QuickOddChangeModal":"QuickOddChangeModal","liveshow-AlertNotice":"liveshow-AlertNotice","openBacoAllTime":"openBacoAllTime","openBacoTime":"openBacoTime","GameCloseTimer":"GameCloseTimer","ModalTableKeno":"ModalTableKeno","ModalTablePk10":"ModalTablePk10","ModalTableQuick10":"ModalTableQuick10","ModalTableQuick3":"ModalTableQuick3","ModalTableSelect5":"ModalTableSelect5","ModalTableSixmark":"ModalTableSixmark","ModalTableSixmarkDaily":"ModalTableSixmarkDaily","ModalTableSsc":"ModalTableSsc"}[chunkId]||chunkId) + "." + {"LidaTable":"94094b49","acout":"58caf3ad","announcement":"31d6cfe0","assort-frist":"31d6cfe0","assort-ledger":"95260e92","chunk-2d0aba47":"31d6cfe0","chunk-2d0b6927":"31d6cfe0","chunk-2d0ba88a":"31d6cfe0","chunk-2d0bce16":"31d6cfe0","chunk-2d0c46b1":"31d6cfe0","chunk-2d0d9f53":"31d6cfe0","chunk-2d0e5b1a":"31d6cfe0","chunk-2d0e91ef":"31d6cfe0","chunk-2d21d846":"31d6cfe0","chunk-2d22c8c1":"31d6cfe0","chunk-2d230be8":"31d6cfe0","chunk-7f1cb5d0":"3b0bf679","common":"31d6cfe0","game-management":"fdc4cb13","general-ledger":"bffda13c","liveshow":"f45c7400","livshow-adjust-odds":"ae9d3014","lottery-kind":"c274c1e5","open-management":"04708ec7","operator":"31d6cfe0","operator-group":"3f9141a1","otherSiteList":"216014d9","period-management":"31d6cfe0","personalCenter":"31d6cfe0","setting":"8fd1a89a","tool_mintable":"31d6cfe0","tool_retime":"31d6cfe0","traderecord":"31d6cfe0","GameGearing":"31d6cfe0","ModalAcountFix":"31d6cfe0","ModalSiteLog":"31d6cfe0","ModalSiteSettings":"31d6cfe0","chunk-e5057956":"64241dc0","ModalEditInside":"31d6cfe0","chunk-2d21675b":"31d6cfe0","liveshow-NavSettingTool":"e3462bdb","liveshow-components":"f89fdff3","liveshow-liveshowGameTabs":"b9685948","tool-ModalBettingList":"31d6cfe0","chunk-10dd34ae":"31d6cfe0","chunk-38c315be":"31d6cfe0","chunk-3a43bc6e":"31d6cfe0","chunk-3f4cb1ae":"31d6cfe0","chunk-42695a73":"31d6cfe0","chunk-42709d36":"31d6cfe0","chunk-4946a530":"31d6cfe0","chunk-75654c40":"31d6cfe0","chunk-9bfb6b88":"3b458bb1","chunk-a16e5492":"31d6cfe0","chunk-b4eb857e":"d82e7be6","chunk-cf7dbe66":"31d6cfe0","chunk-d5325f7a":"82ec187a","ModalBallStatus":"f20c2fd6","period_management":"31d6cfe0","QuickOddChangeModal":"75f447db","liveshow-AlertNotice":"d61e87d6","openBacoAllTime":"31d6cfe0","openBacoTime":"31d6cfe0","chunk-2d0de8f6":"31d6cfe0","chunk-67f905ec":"3863f242","chunk-ea63f694":"670eeae3","GameCloseTimer":"31d6cfe0","ModalTableKeno":"31d6cfe0","ModalTablePk10":"31d6cfe0","ModalTableQuick10":"31d6cfe0","ModalTableQuick3":"31d6cfe0","ModalTableSelect5":"31d6cfe0","ModalTableSixmark":"31d6cfe0","ModalTableSixmarkDaily":"f10479cf","ModalTableSsc":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
